import { render } from "./SubpageContentSection.vue?vue&type=template&id=ede714e8&scoped=true"
import script from "./SubpageContentSection.vue?vue&type=script&lang=js"
export * from "./SubpageContentSection.vue?vue&type=script&lang=js"

import "./SubpageContentSection.vue?vue&type=style&index=0&id=ede714e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ede714e8"

export default script